import axios from 'axios';
import { ACTION_TYPES } from './constants';
import { getProjectTasksFilters } from '../general/selectors';

const baseUrl = process.env.REACT_APP_API_URL;

const config = {
  headers: { Authorization: '' },
};

export const getSectionCountsAction = (projectId, query) => {
  return async (dispatch, getState) => {
    if (!projectId) return;

    try {
      config.headers.Authorization = `Bearer ${localStorage.getItem('token')}`;
      
      const filters = getProjectTasksFilters(getState());
      // Filter out null or empty values
      const filteredFilters = Object.fromEntries(
        Object.entries(filters).filter(([key, value]) => {
          if (key === 'assignedTo' && Array.isArray(value)) {
            return value.length !== 0; // Skip empty assignedTo array
          }
          return value !== null && value !== '' && value !== undefined;
        }),
      );

      // Build query string based on filteredFilters
      let queryString = '';
      if (Object.keys(filteredFilters).length > 0) {
        queryString =
          '?' +
          Object.entries(filteredFilters)
            .map(([key, value]) => `${key}=${key === 'assignedTo' ? value.map((item) => item._id)?.join(',') : value}`)
            .join('&');
      }

      const res = await axios.get(`${baseUrl}/tasks/${projectId}/sections/count${queryString}`, config);

      dispatch({
        type: ACTION_TYPES.GET_SECTIONS_COUNT_REQUEST_SUCCESS,
        payload: res.data?.data,
      });
    } catch (error) {
      console.log("--- error", error)
      dispatch({
        type: ACTION_TYPES.GET_SECTIONS_COUNT_REQUEST_ERROR,
        payload: error,
      });
    }
  };
};


export const updateSectionQueryState = (sectionId) => ({
  type: ACTION_TYPES.UPDATE_SECTION_QUERY_STATE,
  payload: sectionId,
});
